import { supabase } from '../lib/supabase'
import type { Deal } from '../types/index'

function rowToDeal(r: Record<string, unknown>): Deal {
  return {
    id:            r.id as string,
    title:         r.title as string,
    company:       (r.company as string) || '',
    contactName:   (r.contact_name as string) || '',
    value:         (r.value as number) || 0,
    stage:         (r.stage as Deal['stage']) || 'lead',
    probability:   (r.probability as number) || 0,
    expectedClose: (r.expected_close as string) || '',
    notes:         (r.notes as string) || '',
    createdAt:     r.created_at as string,
  }
}

export async function getDeals(): Promise<Deal[]> {
  const { data, error } = await supabase.from('deals').select('*').order('created_at', { ascending: false })
  if (error) throw error
  return (data ?? []).map(rowToDeal)
}

export async function createDeal(d: Omit<Deal, 'id' | 'createdAt'>): Promise<Deal> {
  const { data, error } = await supabase.from('deals').insert({
    title: d.title, company: d.company, contact_name: d.contactName,
    value: d.value, stage: d.stage, probability: d.probability,
    expected_close: d.expectedClose, notes: d.notes,
  }).select().single()
  if (error) throw error
  return rowToDeal(data)
}

export async function updateDeal(id: string, d: Partial<Deal>): Promise<void> {
  const updates: Record<string, unknown> = {}
  if (d.title         !== undefined) updates.title          = d.title
  if (d.company       !== undefined) updates.company        = d.company
  if (d.contactName   !== undefined) updates.contact_name   = d.contactName
  if (d.value         !== undefined) updates.value          = d.value
  if (d.stage         !== undefined) updates.stage          = d.stage
  if (d.probability   !== undefined) updates.probability    = d.probability
  if (d.expectedClose !== undefined) updates.expected_close = d.expectedClose
  if (d.notes         !== undefined) updates.notes          = d.notes
  const { error } = await supabase.from('deals').update(updates).eq('id', id)
  if (error) throw error
}

export async function deleteDeal(id: string): Promise<void> {
  const { error } = await supabase.from('deals').delete().eq('id', id)
  if (error) throw error
}
